import api from '../../services/api'
import { useQuery } from 'react-query'

const fetchReports = () => api.get('/report/search').then((res) => res.data);

export default function useReports() {
  return useQuery('reports', fetchReports);
}